export default __webpack_public_path__ + "static/gaming-d6bcad2c8429ecc9b6d14268f2092c90.webp";